import { TableHead } from "@/components/ui/table";
import { ArrowDown, ArrowUp, ChevronsUpDown } from "lucide-react";
import type { TableSort } from "@/hooks/useTableSort";

interface SortableHeadProps {
  label: string;
  sortKey: string;
  sort: TableSort | null;
  onToggle: (key: string) => void;
  align?: "left" | "right";
  className?: string;
}

/** Clickable table header cell with asc/desc indicator. */
export const SortableHead = ({
  label,
  sortKey,
  sort,
  onToggle,
  align = "left",
  className = "",
}: SortableHeadProps) => {
  const active = sort?.key === sortKey;
  const Icon = active ? (sort!.direction === "asc" ? ArrowUp : ArrowDown) : ChevronsUpDown;
  return (
    <TableHead
      className={`${align === "right" ? "text-right" : ""} ${className}`}
      aria-sort={active ? (sort!.direction === "asc" ? "ascending" : "descending") : undefined}
    >
      <button
        type="button"
        onClick={() => onToggle(sortKey)}
        className={`inline-flex items-center gap-1 hover:text-foreground ${
          align === "right" ? "w-full justify-end" : ""
        } ${active ? "text-foreground font-semibold" : ""}`}
      >
        {label}
        <Icon className="w-3.5 h-3.5 flex-none" />
      </button>
    </TableHead>
  );
};
